import { SortSelector } from "@components/common/sort-selector";
import { PROJECTS_SORT_BY_MAP, PROJECTS_SORT_OPTIONS } from "@components/projects/projects-sort-constants";
import { getProjectsSortBy } from "@components/projects/projects-sort-utils";
import { PaginatedProjects } from "@custom-types/project-types";

/** Component to change the projects sort criteria */
export function ProjectsSort({
  sortBy,
  setSortBy,
}: Pick<PaginatedProjects, "sortBy" | "setSortBy">): JSX.Element {
  return (
    <SortSelector
      sortOptions={PROJECTS_SORT_OPTIONS}
      sortItem={PROJECTS_SORT_BY_MAP[sortBy]}
      setSortItem={(newSortItem) => {
        const newSortBy = getProjectsSortBy(newSortItem);
        setSortBy(newSortBy);
      }}
      subjectType="Project"
    />
  );
}
